var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0983 3.42726C12.0132 3.46112 11.9327 3.50542 11.8585 3.55915C11.3149 4.06275 10.7774 4.57434 10.2358 5.08193L4.78018 10.2038L0 8.44125L14.988 0C14.2066 4.39648 13.4333 8.72702 12.6539 13.1055C11.5088 12.7058 10.3917 12.2662 9.23861 11.8585L6.55076 15C6.55076 13.9648 6.55076 13.0016 6.55076 12.0404C6.55076 11.6407 6.56475 11.241 6.57074 10.8573C6.79856 10.5476 7.02238 10.2378 7.2502 9.93006C8.84892 7.79843 10.443 5.65881 12.0324 3.51119C12.0524 3.48321 12.0683 3.44924 12.0883 3.41926L12.1023 3.40528C12.1043 3.38529 12.1023 3.40927 12.0983 3.42726Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8d19270ec30979207a6ae234650217a5.svg";
export { ForwardRef as ReactComponent };